import {
  faAngleDown,
  faAngleRight,
  faBars,
  faSignInAlt,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import Button from '@atlaskit/button';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { get } from 'lodash';
import {
  BtnMenu,
  BtnSeeMore,
  Container,
  ContainerMenu,
  ItemMenu,
  SeeMore,
} from './styles';
import { apiV2 } from './../../../../services/api';

function Menu({
  primaryColor,
  params,
  setActivedTestimony,
  isDetail,
  retorno,
}) {
  const ref = useRef(null);
  const refOpenMenu = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openSeeMore, setOpenSeeMore] = useState(false);
  const [menus, setMenus] = useState([
    {
      name: 'Vagas',
      link: `/${params}/vacancies`,
    },
    // {
    //   name: 'Login',
    //   link: `${process.env.REACT_APP_TALENT_URL}/${params}/login`,
    //   isLogin: true,
    // },
  ]);

  const nameMenu = {
    about: 'Sobre',
    benefits: 'Benefícios',
    companyValues: 'Valores',
    companyVideo: 'Vídeo',
    socialNetwork: 'Redes Sociais',
    testimonials: 'Depoimentos',
  };

  useEffect(() => {
    async function load() {
      try {
        const { data } = await apiV2.get(`careerpage/sections/get/${params}`);

        // Verificação de segurança para evitar erros quando data é undefined
        if (data && data.data) {
          const menus = Object.keys(get(data, 'data', {})).map(key =>
            get(data, `data.${key}`)
          );

          menus
            ?.filter(
              menu =>
                menu &&
                menu.active &&
                menu.section !== 'banner' &&
                menu.section !== 'contact' &&
                menu.section !== 'configuration'
            )
            ?.forEach(menu => {
              menus.push({
                name: nameMenu[menu.section],
                link: `/${params}/#${menu.section}`,
              });
            });

          if (setActivedTestimony) {
            setActivedTestimony(
              menus?.filter(menu => menu && menu.section === 'testimonials')[0]?.active
            );
          }

          setMenus(menus);
        } else {
          console.warn('API response data structure is invalid in Menu component:', data);
          setMenus([]);
        }
      } catch (error) {
        console.error('Error loading menu data:', error);
        setMenus([]);
      }
    }

    load();
  }, [params, setActivedTestimony]);

  function handleClickMenu() {
    if (!openMenu) {
      document.addEventListener('click', handleOutsideClickMenu, false);
    } else {
      document.removeEventListener('click', handleOutsideClickMenu, false);
    }

    setOpenMenu(open => !open);
  }

  function handleOutsideClickMenu(e) {
    if (!refOpenMenu?.current?.contains(e.target)) setOpenMenu(false);
  }

  function handleClick() {
    if (!openSeeMore) {
      document.addEventListener('click', handleOutsideClick, false);
    } else {
      document.removeEventListener('click', handleOutsideClick, false);
    }

    setOpenSeeMore(open => !open);
  }

  function handleOutsideClick(e) {
    if (!ref?.current?.contains(e.target)) setOpenSeeMore(false);
  }

  // Função utilitária para montar a URL de candidatura corretamente
  function buildSignupUrl(baseUrl, params = {}) {
    const queryParams = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null && value !== '')
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`);
    if (queryParams.length === 0) return baseUrl;
    return `${baseUrl}?${queryParams.join('&')}`;
  }

  return (
    <Container>
      <BtnMenu ref={refOpenMenu} onClick={() => handleClickMenu()}>
        <FontAwesomeIcon icon={openMenu ? faTimes : faBars} />
      </BtnMenu>
      <ContainerMenu isOpenMenu={openMenu} primaryColor={primaryColor === '#ffffff' ? "#000" : primaryColor }>
        {menus?.length > 0 && (
          <ItemMenu login={menus[0]?.isLogin} href={menus[0]?.link}>
            {menus[0]?.name}{' '}
            <FontAwesomeIcon
              icon={menus[0]?.isLogin ? faSignInAlt : faAngleRight}
            />
          </ItemMenu>
        )}
        <div
          className="container-items-seeMore"
          style={{
            position: 'relative',
            display:
              menus?.filter(menu => !menu.isLogin).length > 1
                ? 'block'
                : 'none',
          }}
        >
          <BtnSeeMore ref={ref} onClick={() => handleClick()}>
            Ver mais <FontAwesomeIcon icon={faAngleDown} />
          </BtnSeeMore>
          <SeeMore isOpenSeeMore={openSeeMore}>
            {menus
              ?.filter(menu => !menu.isLogin && menu.name)
              ?.map(
                (menu, index) =>
                  index > 0 && (
                    <ItemMenu
                      key={index}
                      login={menu.isLogin}
                      href={menu.link}
                      color="#475467"
                      onClick={() => setOpenSeeMore(false)}
                    >
                      {menu.name}{' '}
                      <FontAwesomeIcon
                        icon={menu.isLogin ? faSignInAlt : faAngleRight}
                      />
                    </ItemMenu>
                  )
              )}
          </SeeMore>
        </div>

        {menus
          ?.filter(menu => menu.isLogin)
          ?.map(menu => (
            <ItemMenu key={menu.link} login={menu.isLogin} href={menu.link}>
              {menu.name}{' '}
              <FontAwesomeIcon
                icon={menu.isLogin ? faSignInAlt : faAngleRight}
              />
            </ItemMenu>
          ))}

        {isDetail ? (
          <a
            className="btn-register"
            href={buildSignupUrl(
              `${process.env.REACT_APP_TALENT_URL}/${retorno.company.company.label}/${retorno.vacancy.id}/signup`,
              {
                utm_source: retorno.utm_source,
                utm_campaign: retorno.utm_campaign,
                utm_medium: retorno.utm_medium,
              }
            )}
          >
            Candidatar-se para essa vaga
          </a>
        ) : (
          <a
            className="btn-register"
            href={`${process.env.REACT_APP_TALENT_URL}/${params}/signup`}
          >
            Faça parte do nosso Banco de Talentos
          </a>
        )}
      </ContainerMenu>
    </Container>
  );
}

Menu.propTypes = {
  primaryColor: PropTypes.string.isRequired,
  menus: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      isLogin: PropTypes.bool,
    }).isRequired
  ),
};

export default Menu;
